"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dealersDataFactory = exports.defaultDealersStateFactory = void 0;
/** FACTORIES */
var defaultDealersStateFactory = function (config) { return (__assign({ dealers: [], loading: false, locationSearchTerm: '' }, config)); };
exports.defaultDealersStateFactory = defaultDealersStateFactory;
var dealersDataFactory = function (config) { return (__assign({ Address: '', AddressSecond: '', City: '', Components: [], Country: '', CumminsCertified: false, CumminsComponents: [], D12: false, DetroitDealer: '', DetroitDescription: '', EliteSupport: false, FllcCode: '', Freightliner: false, FreightlinerAuthorization: '', FreightlinerDealer: false, Friday: '', Latitude: 1, Longitude: 1, Monday: '', Name: 'My Dealer', Parts: '', PartsExt: '', PartsPhoneNumber: '', Phone: '', RowKey: '', SalesExt: '', SalesPhoneNumber: '', Saturday: '', ServiceExt: '', ServiceHours: [''], ServicePhoneNumber: '', Services: [''], State: '', Status: '', Sunday: '', Thursday: '', TollFreeNumber: '', Tuesday: '', Website: '', Wednesday: '', WesternStar: false, WesternStarAuthorization: '', WesternStarDealer: false, Zip: '' }, config)); };
exports.dealersDataFactory = dealersDataFactory;
